import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { NotificationType } from "../../mainLayer/simulationPopup/NotificationPopup";
import DataTable, {
  GenerateEarlyWarningTypes,
} from "../../mainLayer/simulationPopup/DataTable";
import { map } from "../../mainLayer/MainLayer";
import { Overlay } from "ol";
import ReactDOM from "react-dom";
import loadIco from "../../assets/loading-ico.gif";
import closeIco from "../../assets/close-icon-color.png";
import { ItemTypes, PopupsListType, SimulationType } from "./RightSideMenu";
import TornadoSimulationComp from "../../mainLayer/extremeWeather/tornadoSimulationComp/TornadoSimulationComp";
import ViewMap from "../../simulation/SimulationPopUp/SimulationPopUpMap/ViewSimulationMap";
import ViewForecastMap from "../../simulation/Forecast/ForecastMap/ViewForecastMap";

const rows: GenerateEarlyWarningTypes[] = [
  {
    id: 51040,
    buildingId: 51040,
    buildingType: "BLDGA",
    buildingOwnerName: "Nihal Perera",
    mobileNumber: "0711111111",
    areaOfRisk: "91780.2011292",
    maximumDepth: 200,
    startTime: "05/01/2024, 18:00",
    peakTime: "05/01/2024, 18:00",
  },
  {
    id: 51041,
    buildingId: 51041,
    buildingType: "BLDGA",
    buildingOwnerName: "Gihan Fernando",
    mobileNumber: "0711111111",
    areaOfRisk: "91780.2011292",
    maximumDepth: 200,
    startTime: "05/01/2024, 18:00",
    peakTime: "05/01/2024, 18:00",
  },
];

type TornadoSimPopupsType = {
  setWindowState: Dispatch<React.SetStateAction<boolean>>;
  terminalState: Dispatch<React.SetStateAction<boolean>>;
  terminalCommands: Dispatch<React.SetStateAction<string[]>>;
  notifications: Dispatch<React.SetStateAction<NotificationType[]>>;
  removeItem: (id: string, type: ItemTypes) => void;
  handleClosePopup: () => void;
  runButtonOnClick: (simulationName: string) => void;
  addItem: (id: string, type: ItemTypes) => void;
  data: SimulationType;
  setIsSideMenuSimulationStatus: Dispatch<React.SetStateAction<boolean>>;
};

const SideMenuTornadoSimPopup = (props: TornadoSimPopupsType) => {
  // Selected tab
  const [selectedTab, setSelectedTab] = useState<
    | "simulation_tab"
    | "forecast_tab"
    | "analyse_impact_tab"
    | "generate_early_warning_tab"
  >("simulation_tab");
  // custom value status
  const [isCustomValueOpen, setIsCustomValueOpen] = useState<boolean>(false);
  // Loading screen
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Data
  // Flood model type data
  const [floodModelTypes, setFloodModelTypes] = useState<
    { name: string; value: string }[]
  >([
    { name: "Flood Type 1", value: "floodType_1" },
    { name: "Flood Type 2", value: "floodType_2" },
    { name: "Flood Type 3", value: "floodType_3" },
    { name: "Flood Type 4", value: "floodType_4" },
  ]);
  // Forecast type data
  const [forecastTypes, setForecastTypes] = useState<
    { name: string; value: string }[]
  >([
    { name: "Forecast 1", value: "forecast_1" },
    { name: "Forecast 2", value: "forecast_2" },
    { name: "Forecast 3", value: "forecast_3" },
    { name: "Forecast 4", value: "forecast_4" },
  ]);
  // River sensors data
  const [riverSensorTypes, setRiverSensorTypes] = useState<
    { name: string; value: string }[]
  >([
    { name: "River Sensor 1", value: "river_sensor_1" },
    { name: "River Sensor 2", value: "river_sensor_2" },
    { name: "River Sensor 3", value: "river_sensor_3" },
    { name: "River Sensor 4", value: "river_sensor_4" },
  ]);
  // River sensors data
  const [buildingDataFrom, setBuildingDataFrom] = useState<
    { name: string; value: string }[]
  >([
    { name: "Building Data From 1", value: "building_data_from_1" },
    { name: "Building Data From 2", value: "building_data_from_2" },
    { name: "Building Data From 3", value: "building_data_from_3" },
    { name: "Building Data From 4", value: "building_data_from_4" },
  ]);

  // Input values
  const simulationNameRef = useRef<HTMLInputElement | null>(null);
  const simulationFloodModelRef = useRef<HTMLSelectElement | null>(null);
  const simulationForecastRef = useRef<HTMLSelectElement | null>(null);
  const simulationRiverSensorsRef = useRef<HTMLSelectElement | null>(null);
  const forecastShowCatchmentAreaRef = useRef<HTMLInputElement | null>(null);
  const forecastPublishRef = useRef<HTMLInputElement | null>(null);


  const handleClosePopupClick = () => {
    props.setIsSideMenuSimulationStatus(false);
  };

  // Handle forecast tab next button click
  const handleForecastTabNextButtonClick = () => {
    console.log("forecast tab next button clicked");
    setSelectedTab("analyse_impact_tab");
  };

  // Handle analyse impact tab next button click
  const handleAnalyseImpactTabNextButtonClick = () => {
    console.log("analyse impact tab next button clicked");
    setSelectedTab("generate_early_warning_tab");
  };

  // Handle generate ew tab next button click
  const handleGenerateEWTabNextButtonClick = () => {
    console.log("generate ew tab trigger button clicked");
  };

  // Handle simulation tab next button click
  const handleSimulationTabNextButtonClick = () => {
    setIsLoading(true);
    /* if(simulationNameRef.current?.value && simulationFloodModelRef.current?.value !== 'null' && simulationForecastRef.current?.value !== 'null')
        {
          console.log('run')
        } */
    setIsLoading(true);
    props.terminalState(true);
    props.terminalCommands((prevState) => [
      ...prevState,
      "terminal starting....",
    ]);
    let count = 0;
    const terminalData = setInterval(() => {
      props.terminalCommands((prevState) => [...prevState, "command " + count]);
      count += 1;

      if (count > 10) {
        clearTimeout(terminalData);
        props.terminalCommands((prevState) => [
          ...prevState,
          "terminal ended....",
        ]);
        setIsLoading(false);
        props.notifications((prevState) => [
          ...prevState,
          { type: "success", message: "test successfully completed" },
        ]);
      }
    }, 500);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("tornadoSimElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <TornadoSimulationComp
              terminalState={props.terminalState}
              terminalCommands={props.terminalCommands}
              notifications={props.notifications}
              id={props.data.id}
              addItem={props.addItem}
              handleClosePopup={props.handleClosePopup}
              runButtonOnClick={props.runButtonOnClick}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 80.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "tornado");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  useEffect(() => {
    const handleMouseDown = () => {
      document.addEventListener("mousemove", mouseMoveEvent);
      document.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
    };

    if (popupRef.current) {
      popupRef.current.addEventListener("mouseenter", () => {
        popupRef.current?.addEventListener("mousedown", handleMouseDown);
      });
    }

    return () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [mouseMoveEvent]);

  return (
    <div className={`popup`}>
      <div className={`titleWrapper`} ref={popupRef}>
        <span>Tornado and Severe Thunderstorm Environments simulation</span>
        <div className={`titleButtonContainer no-drag`}>
          <i className={`titleIcon fullScreenIco`}></i>
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => handleClosePopupClick()}
            onTouchStart={(e) => handleClosePopupClick()}
          ></i>
        </div>
      </div>
      {/* Tab area */}
      <div className={`tabArea no-drag`}>
        <div
          className={`tabButton ${
            selectedTab === "simulation_tab" ? "tabSelected" : ""
          }`}
          id="simulation_tab"
          onClick={(e) => setSelectedTab((prevState) => "simulation_tab")}
        >
          simulation
        </div>
        <div
          className={`tabButton ${
            selectedTab === "forecast_tab" ? "tabSelected" : ""
          }`}
          id="forecast_tab"
          onClick={(e) => setSelectedTab((prevState) => "forecast_tab")}
        >
          forecast
        </div>
        <div
          className={`tabButton ${
            selectedTab === "analyse_impact_tab" ? "tabSelected" : ""
          }`}
          id="analyse_impact_tab"
          onClick={(e) => setSelectedTab((prevState) => "analyse_impact_tab")}
        >
          analyse impact
        </div>
        <div
          className={`tabButton ${
            selectedTab === "generate_early_warning_tab" ? "tabSelected" : ""
          }`}
          id="generate_early_warning_tab"
          onClick={(e) =>
            setSelectedTab((prevState) => "generate_early_warning_tab")
          }
        >
          generate early warning
        </div>
      </div>
      <div className={`simulation-wrapper no-drag`}>
        {/* Simulation data container */}
        {selectedTab === "simulation_tab" && (
          <div className={`simulationTabDataWrapper tabDataContainer`}>
            {/* Left data container */}
            <div className={`leftDataContainer`}>
              <div className={`inputItemContainer`}>
                <label htmlFor="simulation_popup_simulation_name_input">
                  simulation name
                </label>
                <input
                  id="simulation_popup_simulation_name_input"
                  type="text"
                  placeholder="Enter Simulation name"
                  ref={simulationNameRef}
                />
              </div>

              <div className={`inputItemContainer`}>
                <label htmlFor="simulation_popup_flood_model_select">
                  model type
                </label>
                <select
                  name="flood_model_type"
                  id="simulation_popup_flood_model_select"
                  ref={simulationFloodModelRef}
                >
                  <option value={""} disabled selected>
                    Select...
                  </option>
                  {floodModelTypes.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={`inputItemContainer`}>
                <label htmlFor="simulation_popup_forecast_select">
                  forecast
                </label>
                <select
                  name="forecast_type"
                  id="simulation_popup_forecast_select"
                  ref={simulationForecastRef}
                >
                  <option value={""} disabled selected>
                    Select...
                  </option>
                  {forecastTypes.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={`customValueWrapper`}>
                <div
                  className={`titleWrapper`}
                  onClick={(e) =>
                    setIsCustomValueOpen((prevStatus) => !prevStatus)
                  }
                >
                  <span className={`title`}>custom value</span>
                  <div
                    className={`icon ${isCustomValueOpen ? "bgUp" : "bgDown"}`}
                  ></div>
                </div>
                <div
                  className={`dataContainer`}
                  style={{ display: isCustomValueOpen ? "block" : "none" }}
                >
                  <div className={`inputItemContainer`}>
                    <label htmlFor="simulation_popup_river_sensors_select">
                      river sensors
                    </label>
                    <select
                      name="river_sensor_type"
                      id="simulation_popup_river_sensors_select"
                      ref={simulationRiverSensorsRef}
                    >
                      <option value={""} disabled selected>
                        Select...
                      </option>
                      {riverSensorTypes.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* Right map container */}
            
            <div className={`rightMapContainer no-drag`}>
              {/* Map here */}
              <ViewMap />
           
            </div>
            <div className={`bottomContainer`}>
              <button onClick={(e) => handleSimulationTabNextButtonClick()}>
                run
              </button>
            </div>
          </div>
        )}

        {/* Forecast data container */}
        {selectedTab === "forecast_tab" && (
          <div className={`forecastTabDataWrapper tabDataContainer`}>
       <div className={`forecastMap no-drag`}>
              {/* Forecast map here */}

              <ViewForecastMap />
            </div>
            <div className={`bottomMenu`}>
              <input
                type="checkbox"
                name=""
                id="simulation_popup_forecast_show_catchment_area"
                ref={forecastShowCatchmentAreaRef}
              />
              <label htmlFor="simulation_popup_forecast_show_catchment_area">
                show catchment area
              </label>

              <input
                type="checkbox"
                name=""
                id="simulation_popup_publish"
                ref={forecastPublishRef}
              />
              <label htmlFor="simulation_popup_publish">publish</label>

              <button onClick={(e) => handleForecastTabNextButtonClick()}>
                next
              </button>
            </div>
          </div>
        )}

        {/* Analyse impact data container */}
        {selectedTab === "analyse_impact_tab" && (
          <div className={`analyseImpactTabDataWrapper tabDataContainer`}>
            <span className={`titleContainer`}>
              Select to generate early warning
            </span>
            <div className={`buildingDataFromSelector`}>
              <label htmlFor="">Building Data From</label>
              <select name="" id="">
                <option value={""} disabled selected>
                  Select...
                </option>
                {buildingDataFrom.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div className={`checkBoxContainer`}>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_buildingID"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_buildingID">Building ID</label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_building_owner_name"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_building_owner_name">
                  Building Owner Name
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_mobile_number"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_mobile_number">
                  Mobile Number
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_building_type"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_building_type">
                  Building Type
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_maximum_depth"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_maximum_depth">
                  Maximum Depth
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_start_time"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_start_time">Start Time</label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_peak_type"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_peak_type">Peak Type</label>
              </div>
            </div>
            <div className={`bottomContainer`}>
              <button onClick={(e) => handleAnalyseImpactTabNextButtonClick()}>
                next
              </button>
            </div>
          </div>
        )}

        {/* Generate early warning data container */}
        {selectedTab === "generate_early_warning_tab" && (
          <div
            className={`generateEarlyWarningTabDataWrapper tabDataContainer`}
          >
            <div className={`tableContainer`}>
              {/* Table here */}
              <DataTable data={rows} />
            </div>

            <div className={`bottomContainer`}>
              <button onClick={(e) => handleGenerateEWTabNextButtonClick()}>
                trigger
              </button>
            </div>
          </div>
        )}

        {/* Loading screen */}
        {isLoading && (
          <div className={`loadingScreen`}>
            <img className={`loadImg`} src={loadIco} alt="" />
            <img
              className={`closeImg`}
              src={closeIco}
              alt=""
              onClick={(e) => {
                setIsLoading(false);
                /* props.terminalState(false)
                            props.terminalCommands([]) */
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SideMenuTornadoSimPopup;
